'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxActions = require('redux-actions');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _WidgetData = require('conversations-schema/records/WidgetData');

var _WidgetData2 = _interopRequireDefault(_WidgetData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = new _WidgetData2.default();

exports.default = (0, _reduxActions.handleActions)(_defineProperty({}, ActionTypes.GET_WIDGET_DATA_SUCCEEDED, function (state, action) {
  return action.payload;
}), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/widget-data/reducers/widgetData.js
// module id = 1273
// module chunks = 3